import React, { SetStateAction, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Upload, Pencil, Copy } from "react-bootstrap-icons";

import { Menu, SortButton, Text } from "./styles";
import { Button } from "../Button";
import { setActiveModal } from "../../store/slices/modals";
import { getProjects } from "../../store/selectors/projects";
import { getAllDatasets } from "../../store/selectors/datasets";
import { SortDropDown } from "../SortDropDown";
import { useOutsideClick } from "../../hooks/useOutsideClick";
import { ChevronUp, ChevronDown } from "react-bootstrap-icons";

interface PageMenuInterface {
  sortBy?: any;
  orderBy?: any;
  setSortBy?: SetStateAction<any>;
  setOrderBy?: SetStateAction<any>;
  handleSortChange?: SetStateAction<any>;
}

export const PageMenu = ({
  sortBy,
  setSortBy,
  handleSortChange,
  setOrderBy,
  orderBy,
}: PageMenuInterface) => {
  const { pathname } = useLocation();
  const { items: projects } = useSelector(getProjects);
  const { items: datasets } = useSelector(getAllDatasets);
  const dispatch = useDispatch();
  const [showDropDown, setShowDropdown] = useState(false);
  const ref = useRef(null);

  useOutsideClick(ref, () => {
    setShowDropdown(false);
  });

  if (pathname === "/projects")
    return (
      <>
        <Menu ref={ref}>
          {projects.length ? (
            <SortButton>
              <Text onClick={() => setShowDropdown(!showDropDown)}>
                {sortBy === "name" ? "Alphabetical" : "Date created"}
                {showDropDown ? <ChevronUp /> : <ChevronDown />}
              </Text>
              {showDropDown && (
                <SortDropDown
                  orderBy={orderBy}
                  setOrderBy={setOrderBy}
                  setSortBy={setSortBy}
                  sortBy={sortBy}
                  handleSortChange={handleSortChange}
                />
              )}
            </SortButton>
          ) : (
            <></>
          )}
          {projects?.length ? (
            <Button
              name="Create Project"
              onClick={() => {
                dispatch(setActiveModal({ id: "createProjectModal" }));
              }}
              icon={<Copy />}
              variant="secondary"
              size="medium"
            />
          ) : (
            <></>
          )}
          {/* <Button
            name="Upload Dataset"
            onClick={() => {
              dispatch(setActiveModal({ id: "uploadDatasetModal" }));
            }}
            icon={<Upload />}
            variant="primary"
            size="medium"
          /> */}
        </Menu>
      </>
    );

  if (pathname === "/programs")
    return (
      <>
        {datasets?.length ? (
          <Menu>
            <Button
              name="Upload Dataset"
              onClick={() =>
                dispatch(setActiveModal({ id: "uploadDatasetModal" }))
              }
              icon={<Upload />}
              variant="primary"
              size="medium"
            />
          </Menu>
        ) : null}
      </>
    );

  if (pathname === "/profile")
    return (
      <Menu>
        <Button
          name="Update profile"
          onClick={() => {
            dispatch(setActiveModal({ id: "uploadProfileMeModal" }));
          }}
          icon={<Pencil />}
          variant="secondary"
          size="medium"
        />
      </Menu>
    );
  else return null;
};
